import axios from 'axios';

const API_URL = 'https://api.ubrenggworks.in/api/products';

// 🔹 Fetch all products (non-paginated)
export const fetchProducts = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

// 🔹 Fetch paginated products
export const fetchPaginatedProducts = async (page = 0, size = 12) => {
  try {
    const response = await axios.get(`${API_URL}?page=${page}&size=${size}`);
    return response.data; // returns { content, totalPages, totalElements, ... }
  } catch (error) {
    console.error('Error fetching paginated products:', error);
    throw error;
  }
};

// 🔹 Add a new product
export const addProduct = async (productData) => {
  try {
    const response = await axios.post(API_URL, productData);
    return response.data;
  } catch (error) {
    console.error('Error adding product:', error);
    throw error;
  }
};

// 🔹 Delete a product by ID
export const deleteProduct = async (id) => {
  try {
    await axios.delete(`${API_URL}/${id}`);
  } catch (error) {
    console.error('Error deleting product:', error);
    throw error;
  }
};

// 🔹 Get a single product by ID
export const getProductById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product by ID:', error);
    throw error;
  }
};

// 🔹 Update a product by ID
export const updateProduct = async (id, updatedData) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, updatedData);
    return response.data;
  } catch (error) {
    console.error('Error updating product:', error);
    throw error;
  }
};
